import { FC, PropsWithChildren } from 'react';

import { GridColumn, GridLayout, GridRow } from '@hh.ru/magritte-ui';

import 'pages/EmptyPage/EmptyPage.less';

import Spinner from 'components/Spinner';

const EmptyPage: FC<PropsWithChildren> = () => {
    return (
        <GridLayout>
            <GridRow>
                <GridColumn xs={4} s={8} m={12}>
                    <div className="empty-page">
                        <Spinner />
                    </div>
                </GridColumn>
            </GridRow>
        </GridLayout>
    );
};

export default EmptyPage;
